// Shared formatting for the storefront UI (plain functions, server- and
// client-safe).

/** "€1,234.56" — symbol comes from the FX payload. */
export const money = (symbol, n) =>
    `${symbol}${(Math.round((Number(n) || 0) * 100) / 100).toLocaleString("en-GB", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })}`;

/** Whole amounts drop the cents: "€55" (falls back to money() otherwise). */
export const moneyCompact = (symbol, n) => {
    const v = Math.round((Number(n) || 0) * 100) / 100;
    return Number.isInteger(v) ? `${symbol}${v.toLocaleString("en-GB")}` : money(symbol, v);
};

// Georgia's calendar, not the visitor's: a trip that starts on 12 Jul in
// Tbilisi must not read "11 Jul" on a laptop in New York.
const SHORT = { month: "short", day: "numeric", timeZone: "Asia/Tbilisi" };

/** "12 Jul" from an ISO string. */
export const fmtShortIso = (iso) =>
    iso ? new Date(iso).toLocaleDateString("en-GB", SHORT) : "";

/** "12 Jul" from a unix-seconds timestamp. */
export const fmtShortTs = (ts) =>
    ts ? new Date(ts * 1000).toLocaleDateString("en-GB", SHORT) : "";

/** "12 Jul – 16 Jul" (single date when equal). */
export const fmtRangeIso = (aIso, bIso) => {
    const a = fmtShortIso(aIso);
    const b = fmtShortIso(bIso);
    return a === b ? a : `${a} – ${b}`;
};

export const plural = (n, word) => `${n} ${word}${n === 1 ? "" : "s"}`;

/** Photo alt for a rental car, e.g. "2023 Toyota Corolla automatic rental car in
 *  Georgia" — a bare model name tells search engines nothing about the offer. */
export const carAlt = (car) =>
    [
        String(car?.year_display ?? "").replace(/\s*-\s*/g, "–"),
        car?.makeTitle,
        car?.modelTitle,
        car?.transmission && String(car.transmission).toLowerCase(),
        "rental car in Georgia",
    ]
        .map((part) => String(part ?? "").trim())
        .filter(Boolean)
        .join(" ");
